import Vue from 'vue';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import store from '@/store';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';

Vue.use(VueRouter);
Vue.use(VueCookies);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'DKC',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!VueCookies.get('token') && !localStorage.getItem('token')) {
    // eslint-disable-next-line no-restricted-globals
    window.location.href = `${process.env.VUE_APP_SSO_URL}login?continue=${location.origin}`;
    next(false);
  }

  if (!store.getters.IS_LOGGED_IN) {
    const token = VueCookies.get('token')
      ? VueCookies.get('token')
      : localStorage.getItem('token');

    axios.get(process.env.VUE_APP_API_ME, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res && res.data && res.data.success) {
          localStorage.setItem('token', token);
          store.dispatch('SET_USER', res.data.data.user);
          store.dispatch('SET_LOGGED_IN', true);
          store.dispatch('SET_TOKEN', token);
          axios.defaults.headers.common.Authorization = `Bearer ${token}`;
          next();
        } else {
          localStorage.removeItem('token');
          // eslint-disable-next-line no-restricted-globals
          window.location.href = `${process.env.VUE_APP_SSO_URL}?continue=${location.origin}`;
          next(false);
        }
      })
      .catch((err) => {
        console.log(err);
        localStorage.removeItem('token');
        if (err.response && (err.response.status === 400 || err.response.status === 401)) {
          // eslint-disable-next-line no-restricted-globals
          window.location.href = `${process.env.VUE_APP_SSO_URL}?continue=${location.origin}`;
          next(false);
        }
        next(false);
      });
  } else {
    next();
  }
});

export default router;
